import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGOUT_USER,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_ERROR,
  CHECK_USER,
  CHECK_USER_SUCCESS,
  CHECK_USER_ERROR,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "../actions";

export const loginUser = (user, history, originURL) => ({
  type: LOGIN_USER,
  payload: { user, history, originURL },
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});

export const forgotPassword = (forgotPassword, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotPassword, history },
});
export const forgotPasswordSuccess = (forgotPassword) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotPassword,
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const resetPassword = ({
  username,
  oldPassword,
  newPassword,
  history,
}) => ({
  type: RESET_PASSWORD,
  payload: { username, oldPassword, newPassword, history },
});
export const resetPasswordSuccess = (resetPassword) => {
  console.log(resetPassword);
  return { type: RESET_PASSWORD_SUCCESS, payload: resetPassword };
};
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message },
});

export const signupUser = (user, history) => ({
  type: SIGNUP_USER,
  payload: { user, history },
});
export const signupUserSuccess = (user) => {
  console.log(user);
  return { type: SIGNUP_USER_SUCCESS, payload: user };
};
export const signupUserError = (message) => ({
  type: SIGNUP_USER_ERROR,
  payload: { message },
});

export const checkUser = (user, history) => ({
  type: CHECK_USER,
  payload: { user, history },
});
export const checkUserSuccess = (user) => {
  console.log(user);
  return { type: CHECK_USER_SUCCESS, payload: user };
};
export const checkUserError = (message) => ({
  type: CHECK_USER_ERROR,
  payload: { message },
});

export const signinUser = (user, history) => ({
  type: SIGNIN_USER,
  payload: { user, history },
});
export const signinUserSuccess = (user) => {
  console.log(user);
  return { type: SIGNIN_USER_SUCCESS, payload: user };
};
export const signinUserError = (message) => ({
  type: SIGNIN_USER_ERROR,
  payload: { message },
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history },
});
export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});
export const registerUserError = (message) => ({
  type: REGISTER_USER_ERROR,
  payload: { message },
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});
